
export const GET_BLOG_CATEGORY_REQUEST = "GET_BLOG_CATEGORY_REQUEST";
export const GET_BLOG_CATEGORY_SUCCESS = "GET_BLOG_CATEGORY_SUCCESS";
export const GET_BLOG_CATEGORY_FAILURE = "GET_BLOG_CATEGORY_FAILURE";